<template>
  <div class="volunteer-detail-wrapper">
    <div class="p-top-wrapper">
      <div class="p-top">
        <div class="p-left" @click="backHome">
          <img :src="require('@/assets/img/common/back_home@2x.png')" alt="" class="p-image-home" />
          <div class="p-backtips">返回首页</div>
        </div>
        <div class="p-arrow-tips"> > </div>
        <div class="p-backtips" @click="$router.push('/voluntary-organization')">志愿组织</div>
        <div class="p-arrow-tips"> > </div>
        <div class="p-map-tips" >{{ detailContent.title }}</div>
      </div>
    </div>
    <div class="volunteer-detail">
      <div class="volunteer-detail-left">
        <div class="vdl-img">
          <img :src="require('@/assets/img/volunteer/zyava.jpeg')" alt="" v-if="detailContent.avatar==null ">
          <img :src="require('@/assets/img/volunteer/zyava.jpeg')" alt="" v-if="detailContent.avatar=='' ">
          <img :src="detailContent.avatar" alt="" v-else>
        </div>
        <div class="vdl-title">
          {{detailContent.title}}
        </div>
        <div class="vdl-address">
          <div class="vdl-address-left">
            <img src="../../../assets/img/common/icon_dizhi@2x.png" alt="">
          </div>
          <div class="vdl-address-right">
            {{detailContent.province_name}}{{detailContent.city_name}}{{detailContent.county_name}}
          </div>
        </div>
        <div class="comein-orginize" v-if="detailContent.is_recruit==0">不开放招募</div>
        <div class="comein-orginize" v-if="detailContent.is_recruit==1 && detailContent.is_signup==0" @click="joinOrg" >加入组织</div>
        <a-popconfirm
            title="确认退出组织吗？"
            ok-text="是"
            cancel-text="否"
            @confirm="quitOrg"
        >
          <div class="comein-orginize" v-if="detailContent.is_recruit==1 && detailContent.is_signup==1"  >已加入</div>
        </a-popconfirm>

        <a-popconfirm
            title="确认取消加入组织吗？"
            ok-text="是"
            cancel-text="否"
            @confirm="cancelApply"
        >
          <div class="comein-orginize" v-if="detailContent.is_recruit==1 && detailContent.is_signup==2"  >审核中</div>
        </a-popconfirm>

      </div>
      <div class="volunteer-detail-right">
        <div class="vdr-top">
          <div class="vdr-top-item">
            <div class="vdr-top-item-title">信用时数</div>
            <div class="vdr-top-item-num">{{detailContent.hours}}<p>小时</p></div>
            <img src="../../../assets/img/volunteer/vdr-top1.png" alt="">
          </div>
          <div class="vdr-top-item">
            <div class="vdr-top-item-title">组织人数</div>
            <div class="vdr-top-item-num">{{detailContent.person}}<p>人</p></div>
            <img src="../../../assets/img/volunteer/vdr-top2.png" alt="">
          </div>
          <div class="vdr-top-item">
            <div class="vdr-top-item-title">发起活动数</div>
                                          <!--            is_recruit-->
            <div class="vdr-top-item-num">{{totalActNum}}<p>个</p></div>
            <img src="../../../assets/img/volunteer/vdr-top3.png" alt="">
          </div>
        </div>
        <div class="vdr-title">
          <img src="../../../assets/img/volunteer/introduce@2x.png" alt="">
          <div class="vdr-title-t">组织介绍</div>
        </div>
        <div class="vdr-content" v-html="detailContent.content">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      detailContent:{

      },
      departmentid:'',
      zyzid:'',
      totalActNum:0
    }
  },
  mounted() {
    this.getParams()
   this.zyzid = localStorage.getItem('jz_vol_zyzid');
    this.getDetail()
    this.actNum()
  },
  methods:{
    //加入组织
    backHome() {
      this.$router.replace({ path: "/" });
    },
    joinOrg(){
      if(!this.zyzid){
        this.$message.info('您还没有登录哦～')
        this.$router.push('/login')
        return
      }
      this.$api.vmsapi
          .recruitOrgJoin({
            zyzid: this.zyzid,
            id:this.departmentid,
            sourceid: 'wezy'
          }).then(res=>{
            if(res.errCode=='0000'){
              this.$message.info('您已成功提交加入组织申请，请关注审核状态')
              this.getDetail()
            }
      })
    },
    //退出组织

    quitOrg(){
      this.$api.vmsapi
          .recruitOrgQuit({
            zyzid: this.zyzid,
            id: this.departmentid
          }).then(res=>{
            console.log(res,'ccc')
        if(res.errCode=='0000'){
          this.$message.info('退出组织成功')
          this.getDetail()
        }
      })
    },
    //取消加入
    cancelApply(){
      this.$api.vmsapi
          .recruitOrgCancel({
            zyzid: this.zyzid,
            id: this.departmentid
          }).then(res=>{
        if(res.errCode=='0000'){
          this.$message.info('您已取消加入组织')
          this.getDetail()
        }
      })
    },
    //获取组织id
    getParams(){
      this.departmentid = this.$route.params.id
    },
    //获取内容
    getDetail(){
      this.$api.vmsapi
          .recruitOrgDetail({
            zyzid: this.zyzid,
            id: this.departmentid
          }).then(res=>{
            this.detailContent=res
        console.log(res,111)
      })
    },
    //获取组织活动数量
    actNum(){
      this.$api.vmsapi
          .recruitOrgActNum({
            page: 1,
            pageSize: 5,
            deptId:this.departmentid
          }).then(res=>{
            console.log(res);
            this.totalActNum = res.data.total
          })
    }
  }
}
</script>

<style lang="scss" scoped>
.p-top-wrapper{
  width: 1200px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.p-top {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 16px;
  margin-bottom: 57px;
  .p-left {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 16px;
    .p-image-home {
      width: 26px;
      height: 26px;
      margin-right: 6px;
    }
  }
  .p-arrow-tips {
    margin: 0 5px;
  }
  .p-map-tips {
    cursor: pointer;
    color: #CD3232;
  }
}
.volunteer-detail-wrapper{
  width: 100%;
  padding-bottom: 50px;
  background:#fbfbfb ;
  padding-top: 20px;
}
.volunteer-detail{
  width: 1200px;
  position: relative;
  left:50%;
  transform: translateX(-50%);
  background: #FFFFFF;
  padding:30px 30px 50px 30px;
  display: flex;
  flex-direction: row;
  .volunteer-detail-left{
    text-align: left;
    .vdl-img{
      height: 180px;
      width: 320px;
      display: table-cell;
      vertical-align: middle;
      display: flex;
      align-items: center;
      img{
        max-width: 100%;
        max-height: 100%;
        display: block;
        margin: auto;
      }
    }

    .vdl-title{
      margin-top: 20px;
      font-size: 20px;
      font-family: Helvetica;
      color: #333333;
      line-height: 20px;
    }
    .vdl-address{
      display: flex;
      flex-direction: row;
      margin-top: 10px;

      .vdl-address-left{
        img{width: 10px;height: 10px;margin-right: 4px;}
      }
      .vdl-address-right{
        font-size: 12px;
        font-family: STHeitiSC-Light, STHeitiSC;
        font-weight: 300;
        color: #666666;
        line-height: 12px;
      }
    }
    .comein-orginize{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      width: 320px;
      height: 32px;
      background: #CD3232;
      border-radius: 2px;
      font-size: 14px;
      font-family: Helvetica;
      color: #FFFFFF;
      line-height: 14px;
    }

  }
  .volunteer-detail-right{
    margin-left: 80px;
    display: flex;
    flex-direction: column;
    .vdr-top{
      display: flex;
      flex-direction: row;
      .vdr-top-item{
        margin-right:25px ;
        position: relative;
        .vdr-top-item-title{
          left: 20px;
          top:20px;
          position: absolute;
          font-size: 16px;
          font-family: Helvetica;
          color: #727384;
          line-height: 16px;
        }
        .vdr-top-item-num{
          left: 20px;
          top: 66px;
          font-size: 24px;
          font-family: Helvetica;
          color: #333333;
          line-height: 24px;
          position: absolute;
          display: flex;
          p{
            font-size: 14px;
            font-family: Helvetica;
            color: #727384;
            line-height: 14px;
            margin-top: 6px;
            margin-left: 10px;
          }
        }
        img{
          width: 230px;
          height: 130px;
        }
      }
    }
    .vdr-title{
      margin-top:50px;
      display: flex;
      flex-direction: row;
      img{
        width: 15px;
        height: 15px;
        margin-right: 8px;
      }

      .vdr-title-t{
        font-size: 15px;
        font-family: Helvetica;
        color: #333333;
        line-height: 15px;
      }
    }
    .vdr-content{
      padding-right: 10px;
      margin-top: 20px;
      font-size: 14px;
      font-family: Helvetica;
      color: #333333;
      line-height: 24px;
      text-align: left;
    }
  }
}

</style>